var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutusicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.8836H3.33325C2.22868 13.8836 1.33325 12.9882 1.33325 11.8836V2.55029C1.33325 1.44572 2.22868 0.550293 3.33325 0.550293H9.99992C11.1045 0.550293 11.9999 1.44572 11.9999 2.55029V4.55029M13.3333 13.8836C12.5969 13.8836 11.9999 13.2867 11.9999 12.5503V4.55029M13.3333 13.8836C14.0696 13.8836 14.6666 13.2867 14.6666 12.5503V5.88363C14.6666 5.14725 14.0696 4.55029 13.3333 4.55029H11.9999M3.99992 3.88363H9.33325M3.99992 7.21696H9.33325M3.99992 10.5503H6.66659",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusicon);
export default __webpack_public_path__ + "static/media/aboutusicon.472893864292342afa308205d88627ba.svg";
export { ForwardRef as ReactComponent };